import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Form } from 'redux-form';

import { Button } from '../../common';

const UserInfoItemForm = reduxForm({ enableReinitialize: true })(
  ({ styles, form: type, children, onSubmit, handleSubmit }) => (
    <Form
      className={styles['profile-user-info-item__wrapper']}
      onSubmit={handleSubmit(values => onSubmit({ ...values, type }))}
    >
      {children}
      <Button
        type="submit"
        id={`page.profile.component.${type}.submit-button`}
        className={styles['profile-user-info-item__button']}
      >
        speichern
      </Button>
    </Form>
  )
);

const UserInfoItem = ({ type, ...props }) => (
  <UserInfoItemForm {...props} form={type} />
);

UserInfoItem.propTypes = {
  styles: PropTypes.object
};

export default UserInfoItem;
